export const TAGLIST_SEARCH = 'TAGLIST_SEARCH';
export const TAGLIST_PAGE = 'TAGLIST_PAGE';
